import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useHistory, useParams, useLocation } from "react-router-dom";

import AnonymousPageView from "../common/AnonymousPageView";

import _ from "lodash";
import styles from "./acceptInvitation.module.scss";
import cx from "classnames";
import { Button, Form } from "react-bootstrap";

import { fetchUserInvitation, registerInviteUser } from "actions/users";
import cleverStoryLogo from "../../../assets/images/logo/logo-cs.svg";

export default function AcceptInvitation() {
  const dispatch = useDispatch();

  const { id } = useParams();
  const location = useLocation();
  const paramsString = location.search;
  const params = new URLSearchParams(paramsString);
  var key = params.get("key");

  const invitation = useSelector((state) =>
    _.get(state, "users.invitation.item")
  );

  const loading = useSelector((state) =>
    _.get(state, "users.invitation.loading")
  );

  const registrationError = useSelector((state) =>
    _.get(state, "users.registration.error", null)
  );

  const invitationError = useSelector((state) =>
    _.get(state, "users.invitation.error", null)
  );

  useEffect(() => {
    dispatch(fetchUserInvitation(id, key));
  }, []);

  return (
    <AnonymousPageView>
      <div className={cx(styles.invitationForm)}>
        <div className={styles.logoContainer}>
          <img src={cleverStoryLogo} alt="Cleverstory logo" />
        </div>
        {loading && <LoadingMessage />}
        {!loading && registrationError && (
          <ErrorMessage errors={registrationError} />
        )}
        {!loading && invitationError && (
          <ErrorMessage errors={invitationError} />
        )}
        {!loading && !registrationError && !invitationError && invitation && (
          <AcceptInvitationForm id={id} />
        )}
      </div>
    </AnonymousPageView>
  );
}

const LoadingMessage = () => {
  return (
    <div className={cx(styles.loadingContainer)}>
      <div className={styles.inner}>
        <p>Recovering Account...</p>
      </div>
    </div>
  );
};

const ErrorMessage = (errors) => {
  const history = useHistory();

  const handleSignupClick = () => {
    history.push("/login");
  };

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (errors.errors[0].code === 10002) {
      setErrorMessage("Can't find invitation");
    } else if (errors.errors[0].code === 20002) {
      setErrorMessage("Unable to activate invitation");
    }
  }, [errors]);

  return (
    <div>
      <h1 className={styles.errorHeading}>{errorMessage}</h1>
      <p className={styles.errorMessage}>
        This invite seems to be invalid. Get in touch with your administrator.
      </p>
      <div className={styles.buttonContainer}>
        <Button className={styles.confirm} onClick={handleSignupClick}>
          Sign In
        </Button>
      </div>
    </div>
  );
};

const AcceptInvitationForm = ({ id }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const invitation = useSelector((state) =>
    _.get(state, "users.invitation.item")
  );

  const loading = useSelector((state) =>
    _.get(state, "users.registration.loading")
  );

  const [state, setState] = useState({
    password: "",
    firstName: "",
    lastName: "",
    termsAndConditions: false,
    errors: {},
    postConfirm: false,
  });

  const handleChange = (field, e) => {
    setState((state) => {
      return {
        ...state,
        [field]: e.target.value,
        errors: {},
      };
    });
  };

  const handleTermsAndConditionsClick = () => {
    let termsAndConditions = !state.termsAndConditions;
    setState((state) => {
      return {
        ...state,
        termsAndConditions: termsAndConditions,
      };
    });
  };

  const validateForm = () => {
    let errors = {};
    const { firstName, password, termsAndConditions } = state;
    if (!firstName || firstName.trim() === "") {
      errors.firstName = "Please enter a valid name";
    }

    if (!invitation.ssoLoginMandatory && (!password || password.length < 8)) {
      errors.password = "Password should contain at least 8 characters";
    }

    if (!termsAndConditions) {
      errors.termsAndConditions = "Please check the terms and Conditons";
    }

    return errors;
  };

  const handleSignUpClick = (e) => {
    e.preventDefault();

    const errors = validateForm();

    setState((state) => {
      return {
        ...state,
        errors: errors,
      };
    });

    if (Object.keys(errors).length !== 0) {
      return;
    }

    let user = {
      firstName: state.firstName,
      lastName: state.lastName,
      email: invitation.email,
      password: state.password,
    };

    dispatch(
      registerInviteUser(id, user, () => {
        setState((state) => {
          return {
            ...state,
            postConfirm: true,
          };
        });
      })
    );
  };

  const handleSigninClick = () => {
    history.push("/login");
  };

  return (
    <div className={styles.content}>
      <div>
        {state.postConfirm && (
          <>
            <div className={styles.heading}>
              <h4 className={styles.header}>
                Congratulations! <br />
                You have created your account
              </h4>
              <p>
                The team and I are super excited to have you join us. A growing
                number of driven enterprises are successfully using cleverstory
                to make meaningful conversations with their customers to ace
                business deals!
              </p>
            </div>
            <div className={styles.buttonContainer} onClick={handleSigninClick}>
              <Button className={styles.signupButton}>Sign In</Button>
            </div>
          </>
        )}

        {!state.postConfirm && (
          <>
            <header className={styles.header}>Welcome aboard! Let's get you started!</header>

            <Form onSubmit={handleSignUpClick}>
              <Form.Group className={styles.acceptInvitationFormGroup}>
                <Form.Control
                  id="email"
                  type="text"
                  placeholder="Work Email"
                  className={styles.acceptInvitationInput}
                  value={invitation.email}
                  disabled
                />
              </Form.Group>

              {!invitation.ssoLoginMandatory && (
                <Form.Group className={styles.acceptInvitationFormGroup}>
                  <Form.Control
                    label="Password"
                    id="password"
                    placeholder="Password"
                    className={styles.acceptInvitationInput}
                    value={state.password}
                    type="password"
                    onChange={handleChange.bind(this, "password")}
                    isInvalid={state.errors.password}
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className={styles.error}
                  >
                    {state.errors.password}
                  </Form.Control.Feedback>
                </Form.Group>
              )}

              <Form.Group className={styles.acceptInvitationFormGroup}>
                <Form.Control
                  label="firstName"
                  name="firstName"
                  placeholder="First Name"
                  className={styles.acceptInvitationInput}
                  value={state.firstName}
                  type="text"
                  onChange={handleChange.bind(this, "firstName")}
                  isInvalid={state.errors.firstName}
                />
                <Form.Control.Feedback type="invalid" className={styles.error}>
                  {state.errors.firstName}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className={styles.acceptInvitationFormGroup}>
                <Form.Control
                  label="Last Name"
                  id="lastName"
                  placeholder="Last Name"
                  className={styles.acceptInvitationInput}
                  value={state.lastName}
                  type="text"
                  onChange={handleChange.bind(this, "lastName")}
                />
              </Form.Group>

              <Form.Group className={styles.termAndConitions}>
                <Form.Check
                  type="radio"
                  className={styles.termAndConitionsFormCheck}
                >
                  <Form.Check.Input
                    className={styles.termAndConitionsBox}
                    type="checkbox"
                    isInvalid={state.errors.termsAndConditions}
                    onClick={handleTermsAndConditionsClick}
                    value={state.termsAndConditions}
                  />
                  <Form.Check.Label>
                    I agree to &nbsp;&nbsp;
                    <a
                      className={styles.termAndConitionsLink}
                      href="https://app.paperflite.com/terms"
                      target="_blank"
                      rel="noreferrer"
                    >
                      terms and conditions
                    </a>
                  </Form.Check.Label>
                  <Form.Control.Feedback
                    type="invalid"
                    className={styles.error}
                  >
                    {state.errors.termsAndConditions}
                  </Form.Control.Feedback>
                </Form.Check>
              </Form.Group>

              <Button type="submit" className={styles.signupButton}>
                {loading ? "Processing..." : "Sign Up"}
              </Button>
            </Form>
          </>
        )}
      </div>
    </div>
  );
};
